export const getTrailId = (status) => ({ ingles: 9, leitura: 2, matematica: 3, redacao: 4 }[status]);
